import { useState } from 'react';
import AdminAnalyticsPanel from '../components/AdminAnalyticsPanel';
import AdminMatchesPanel from '../components/AdminMatchesPanel';
import CurationPanel from '../components/CurationPanel';
import UserAdminPanel from '../components/UserAdminPanel';
import { useAuth } from '../context/AuthContext';

type AdminTab = 'analytics' | 'curation' | 'matches' | 'users';

const tabOptions: Array<{ label: string; value: AdminTab }> = [
  { label: 'Acessos', value: 'analytics' },
  { label: 'Curadoria', value: 'curation' },
  { label: 'Matches', value: 'matches' },
  { label: 'Usuários', value: 'users' },
];

const Admin = () => {
  const { user } = useAuth();
  const [tab, setTab] = useState<AdminTab>('analytics');
  const [refreshToken, setRefreshToken] = useState(0);

  if (!user) return null;

  return (
    <div className="portal-page">
      <section className="hero-section py-4 position-relative overflow-hidden">
        <div className="hero-blur" />
        <div className="container py-4">
          <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
            <div>
              <span className="badge bg-brand text-white fw-semibold px-3 py-2 rounded-pill mb-3">
                Administração
              </span>
              <h1 className="text-white mb-2">Métricas, curadoria e matches</h1>
              <p className="text-white-50 mb-0">
                Painel único para acompanhar acesso, decidir publicações e gerir permissões.
              </p>
            </div>
            <div className="text-end">
              <div className="text-white fw-semibold">{user.name}</div>
              <div className="text-white-50 small">Administrador</div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 section-contrast">
        <div className="container">
          <div className="tab-strip mb-4">
            {tabOptions.map((item) => (
              <button
                key={item.value}
                type="button"
                className={`btn ${tab === item.value ? 'btn-brand' : 'btn-outline-light'}`}
                onClick={() => setTab(item.value)}
              >
                {item.label}
              </button>
            ))}
          </div>

          {tab === 'analytics' && <AdminAnalyticsPanel />}

          {tab === 'curation' && (
            <CurationPanel
              adminId={user.id}
              refreshToken={refreshToken}
              onActionComplete={() => setRefreshToken((current) => current + 1)}
            />
          )}

          {tab === 'matches' && <AdminMatchesPanel refreshToken={refreshToken} />}

          {tab === 'users' && (
            <UserAdminPanel
              refreshToken={refreshToken}
              onActionComplete={() => setRefreshToken((current) => current + 1)}
            />
          )}
        </div>
      </section>
    </div>
  );
};

export default Admin;
